export default __webpack_public_path__ + "static/media/dining-room.cd8fac85.jpg";